"use client";

import { useEffect } from "react";

// The home page's decorative loops (floating mockups, marquee, button shine) only run while
// they're on screen and the tab is visible – otherwise they keep the GPU busy for nothing.
export default function MotionPause() {
  useEffect(() => {
    const els = [...document.querySelectorAll(".lp-float, .lp-marquee, .lp-shine")];
    if (!els.length || typeof IntersectionObserver === "undefined") return;
    const visible = new Map();
    const apply = () => els.forEach((el) => el.classList.toggle("lp-paused", document.hidden || !visible.get(el)));
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => visible.set(e.target, e.isIntersecting));
      apply();
    });
    els.forEach((el) => {
      el.classList.add("lp-paused");
      io.observe(el);
    });
    document.addEventListener("visibilitychange", apply);
    return () => {
      io.disconnect();
      document.removeEventListener("visibilitychange", apply);
    };
  }, []);
  return null;
}
